import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imGeneratingJournal', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/details/generate-journal/generate-journal.html'),
        controller: 'GenerateJournalController',
        controllerAs: 'GenerateJournalCtrl',
        bindings: {
            journal: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/generate-journal/generate-journal.component.ts